import {PageDataProps} from "./AppContextTypes";
import {DataResource} from "../../hooks/useDataResource";
import {ConversationMessage} from "../../types/ConversationMessage";
import {CreateFlowDataProps} from "../../api/createFlow";
import {CreateCampaignDataProps} from "../../api/createCampaign";

const defaultPageData: PageDataProps = {
    data: [],
    isFullyLoaded: false,
    page: 0
}

const defaultDataResource: DataResource = {
    data: [],
    setData: (a: any) => null,
    isLoading: false,
    setIsLoading: (a: boolean) => null,
    isLoaded: false,
    load: (a: any) => null,
    clear: () => null,
}

export const defaultAppContextValue = {
    days: 90,
    actions: {
        setDays: (newDays: number) => null,
        sendNotificationPreview: (domain: string, id: number) => Promise.resolve({ data: null, status: 500 }),
        createNotification: (domain: string, flowId: number, notificationData: any) => Promise.resolve({ data: null, status: 500 }),
        createFlow: (domain: string, data: CreateFlowDataProps) => Promise.resolve({ data: null, status: 500 }),
        createCampaign: (domain: string, data: CreateCampaignDataProps) => Promise.resolve({ data: null, status: 500 }),
        editNotification: (domain: string, notificationId: number, flowId: number, notificationData: any) => Promise.resolve({ data: null, status: 500 }),
        deleteNotification: (domain: string, flowId: number, notificationId: number) => Promise.resolve({ data: null, status: 500 }),
        loadFlows: () => {},
        loadTemplates: () => {},
        loadCampaigns: () => {},
        loadWaba: () => null,
        loadShop: () => null,
        loadShopClients: () => null,
        loadMore: (source: string) => null,
        clearData: () => null,
        removeFlow: (id: number) => null,
        removeTemplate: (id: number) => null,
        loadBlackoutPeriods: () => null,
        setBalance: () => null,
        loadShopifyBillingDetails: () => null,
        loadConversationMessages: (conversationId: number) => null,
        addMessageToConversation: (newMessage: ConversationMessage) => null,
        setConversationAsSeen: (conversationId: number) => null,
        setCurrentConversationId: (conversationId: number | null) => null,
        loadSegments: () => null,
        loadDiscounts: () => null,
    },
    data: {
        abandonedCheckouts: defaultDataResource,
        orders: defaultDataResource,
        flows: defaultDataResource,
        flowTypes: defaultDataResource,
        flowTriggers: defaultDataResource,
        templates: defaultDataResource,
        campaigns: defaultDataResource,
        waba: defaultDataResource,
        phone: undefined,
        shop: defaultDataResource,
        conversations: defaultDataResource,
        conversationMessages: new Map(),
        templatesAnalyzer: defaultDataResource,
        conversionsOverTime: defaultDataResource,
        checkoutRecoverableVsRecovered: defaultDataResource,
        totalRecovered: defaultDataResource,
        dashboardBoxes: defaultDataResource,
        lastDaysMessages: defaultDataResource,
        lastDaysCheckouts: defaultDataResource,
        lastDaysOrders: defaultDataResource,
        lastDaysCampaigns: defaultDataResource,
        campaignBoxes: defaultDataResource,
        campaignsAvg: defaultDataResource,
        blackoutPeriods: defaultDataResource,
        shopifyBillingDetails: defaultDataResource,
        totalUnseenMessages: 0,
        segments: defaultDataResource,
        shopClients: defaultDataResource,
        isChatSocketReady: false,
        discounts: defaultDataResource,
    },
}